import { w as M } from "./wordlist-kip2xntm.js";
import { c as x, C as F, P as V } from "./errors-CoLhPo2G.js";
import { L as E, C as I, a as z, B as N } from "./CharRule-CMjLCJA6.js";
function $(l) {
  throw new Error('Could not dynamically require "' + l + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var j = { exports: {} };
(function(l, r) {
  (function(e, s) {
    l.exports = s();
  })(x, function() {
    var e = e || function(s, i) {
      var o;
      if (typeof window < "u" && window.crypto && (o = window.crypto), typeof self < "u" && self.crypto && (o = self.crypto), typeof globalThis < "u" && globalThis.crypto && (o = globalThis.crypto), !o && typeof window < "u" && window.msCrypto && (o = window.msCrypto), !o && typeof x < "u" && x.crypto && (o = x.crypto), !o && typeof $ == "function")
        try {
          o = require("crypto");
        } catch {
        }
      var g = function() {
        if (o) {
          if (typeof o.getRandomValues == "function")
            try {
              return o.getRandomValues(new Uint32Array(1))[0];
            } catch {
            }
          if (typeof o.randomBytes == "function")
            try {
              return o.randomBytes(4).readInt32LE();
            } catch {
            }
        }
        throw new Error("Native crypto module could not be used to get secure random number.");
      }, p = Object.create || /* @__PURE__ */ function() {
        function t() {
        }
        return function(n) {
          var a;
          return t.prototype = n, a = new t(), t.prototype = null, a;
        };
      }(), w = {}, f = w.lib = {}, u = f.Base = /* @__PURE__ */ function() {
        return {
          /**
           * Creates a new object that inherits from this object.
           *
           * @param {Object} overrides Properties to copy into the new object.
           *
           * @return {Object} The new object.
           *
           * @static
           *
           * @example
           *
           *     var MyType = CryptoJS.lib.Base.extend({
           *         field: 'value',
           *
           *         method: function () {
           *         }
           *     });
           */
          extend: function(t) {
            var n = p(this);
            return t && n.mixIn(t), (!n.hasOwnProperty("init") || this.init === n.init) && (n.init = function() {
              n.$super.init.apply(this, arguments);
            }), n.init.prototype = n, n.$super = this, n;
          },
          /**
           * Extends this object and runs the init method.
           * Arguments to create() will be passed to init().
           *
           * @return {Object} The new object.
           *
           * @static
           *
           * @example
           *
           *     var instance = MyType.create();
           */
          create: function() {
            var t = this.extend();
            return t.init.apply(t, arguments), t;
          },
          /**
           * Initializes a newly created object.
           * Override this method to add some logic when your objects are created.
           *
           * @example
           *
           *     var MyType = CryptoJS.lib.Base.extend({
           *         init: function () {
           *             // ...
           *         }
           *     });
           */
          init: function() {
          },
          /**
           * Copies properties into this object.
           *
           * @param {Object} properties The properties to mix in.
           *
           * @example
           *
           *     MyType.mixIn({
           *         field: 'value'
           *     });
           */
          mixIn: function(t) {
            for (var n in t)
              t.hasOwnProperty(n) && (this[n] = t[n]);
            t.hasOwnProperty("toString") && (this.toString = t.toString);
          },
          /**
           * Creates a copy of this object.
           *
           * @return {Object} The clone.
           *
           * @example
           *
           *     var clone = instance.clone();
           */
          clone: function() {
            return this.init.prototype.extend(this);
          }
        };
      }(), C = f.WordArray = u.extend({
        /**
         * Initializes a newly created word array.
         *
         * @param {Array} words (Optional) An array of 32-bit words.
         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
         *
         * @example
         *
         *     var wordArray = CryptoJS.lib.WordArray.create();
         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
         */
        init: function(t, n) {
          t = this.words = t || [], n != i ? this.sigBytes = n : this.sigBytes = t.length * 4;
        },
        /**
         * Converts this word array to a string.
         *
         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
         *
         * @return {string} The stringified word array.
         *
         * @example
         *
         *     var string = wordArray + '';
         *     var string = wordArray.toString();
         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
         */
        toString: function(t) {
          return (t || H).stringify(this);
        },
        /**
         * Concatenates a word array to this word array.
         *
         * @param {WordArray} wordArray The word array to append.
         *
         * @return {WordArray} This word array.
         *
         * @example
         *
         *     wordArray1.concat(wordArray2);
         */
        concat: function(t) {
          var n = this.words, a = t.words, c = this.sigBytes, h = t.sigBytes;
          if (this.clamp(), c % 4)
            for (var d = 0; d < h; d++) {
              var W = a[d >>> 2] >>> 24 - d % 4 * 8 & 255;
              n[c + d >>> 2] |= W << 24 - (c + d) % 4 * 8;
            }
          else
            for (var m = 0; m < h; m += 4)
              n[c + m >>> 2] = a[m >>> 2];
          return this.sigBytes += h, this;
        },
        /**
         * Removes insignificant bits.
         *
         * @example
         *
         *     wordArray.clamp();
         */
        clamp: function() {
          var t = this.words, n = this.sigBytes;
          t[n >>> 2] &= 4294967295 << 32 - n % 4 * 8, t.length = s.ceil(n / 4);
        },
        /**
         * Creates a copy of this word array.
         *
         * @return {WordArray} The clone.
         *
         * @example
         *
         *     var clone = wordArray.clone();
         */
        clone: function() {
          var t = u.clone.call(this);
          return t.words = this.words.slice(0), t;
        },
        /**
         * Creates a word array filled with random bytes.
         *
         * @param {number} nBytes The number of random bytes to generate.
         *
         * @return {WordArray} The random word array.
         *
         * @static
         *
         * @example
         *
         *     var wordArray = CryptoJS.lib.WordArray.random(16);
         */
        random: function(t) {
          for (var n = [], a = 0; a < t; a += 4)
            n.push(g());
          return new C.init(n, t);
        }
      }), B = w.enc = {}, H = B.Hex = {
        /**
         * Converts a word array to a hex string.
         *
         * @param {WordArray} wordArray The word array.
         *
         * @return {string} The hex string.
         *
         * @static
         *
         * @example
         *
         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
         */
        stringify: function(t) {
          for (var n = t.words, a = t.sigBytes, c = [], h = 0; h < a; h++) {
            var d = n[h >>> 2] >>> 24 - h % 4 * 8 & 255;
            c.push((d >>> 4).toString(16)), c.push((d & 15).toString(16));
          }
          return c.join("");
        },
        /**
         * Converts a hex string to a word array.
         *
         * @param {string} hexStr The hex string.
         *
         * @return {WordArray} The word array.
         *
         * @static
         *
         * @example
         *
         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
         */
        parse: function(t) {
          for (var n = t.length, a = [], c = 0; c < n; c += 2)
            a[c >>> 3] |= parseInt(t.substr(c, 2), 16) << 24 - c % 8 * 4;
          return new C.init(a, n / 2);
        }
      }, A = B.Latin1 = {
        /**
         * Converts a word array to a Latin1 string.
         *
         * @param {WordArray} wordArray The word array.
         *
         * @return {string} The Latin1 string.
         *
         * @static
         *
         * @example
         *
         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
         */
        stringify: function(t) {
          for (var n = t.words, a = t.sigBytes, c = [], h = 0; h < a; h++) {
            var d = n[h >>> 2] >>> 24 - h % 4 * 8 & 255;
            c.push(String.fromCharCode(d));
          }
          return c.join("");
        },
        /**
         * Converts a Latin1 string to a word array.
         *
         * @param {string} latin1Str The Latin1 string.
         *
         * @return {WordArray} The word array.
         *
         * @static
         *
         * @example
         *
         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
         */
        parse: function(t) {
          for (var n = t.length, a = [], c = 0; c < n; c++)
            a[c >>> 2] |= (t.charCodeAt(c) & 255) << 24 - c % 4 * 8;
          return new C.init(a, n);
        }
      }, q = B.Utf8 = {
        /**
         * Converts a word array to a UTF-8 string.
         *
         * @param {WordArray} wordArray The word array.
         *
         * @return {string} The UTF-8 string.
         *
         * @static
         *
         * @example
         *
         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
         */
        stringify: function(t) {
          try {
            return decodeURIComponent(escape(A.stringify(t)));
          } catch {
            throw new Error("Malformed UTF-8 data");
          }
        },
        /**
         * Converts a UTF-8 string to a word array.
         *
         * @param {string} utf8Str The UTF-8 string.
         *
         * @return {WordArray} The word array.
         *
         * @static
         *
         * @example
         *
         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
         */
        parse: function(t) {
          return A.parse(unescape(encodeURIComponent(t)));
        }
      }, _ = f.BufferedBlockAlgorithm = u.extend({
        /**
         * Resets this block algorithm's data buffer to its initial state.
         *
         * @example
         *
         *     bufferedBlockAlgorithm.reset();
         */
        reset: function() {
          this._data = new C.init(), this._nDataBytes = 0;
        },
        /**
         * Adds new data to this block algorithm's buffer.
         *
         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
         *
         * @example
         *
         *     bufferedBlockAlgorithm._append('data');
         *     bufferedBlockAlgorithm._append(wordArray);
         */
        _append: function(t) {
          typeof t == "string" && (t = q.parse(t)), this._data.concat(t), this._nDataBytes += t.sigBytes;
        },
        /**
         * Processes available data blocks.
         *
         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
         *
         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
         *
         * @return {WordArray} The processed data.
         *
         * @example
         *
         *     var processedData = bufferedBlockAlgorithm._process();
         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
         */
        _process: function(t) {
          var n, a = this._data, c = a.words, h = a.sigBytes, d = this.blockSize, W = d * 4, m = h / W;
          t ? m = s.ceil(m) : m = s.max((m | 0) - this._minBufferSize, 0);
          var b = m * d, D = s.min(b * 4, h);
          if (b) {
            for (var R = 0; R < b; R += d)
              this._doProcessBlock(c, R);
            n = c.splice(0, b), a.sigBytes -= D;
          }
          return new C.init(n, D);
        },
        /**
         * Creates a copy of this object.
         *
         * @return {Object} The clone.
         *
         * @example
         *
         *     var clone = bufferedBlockAlgorithm.clone();
         */
        clone: function() {
          var t = u.clone.call(this);
          return t._data = this._data.clone(), t;
        },
        _minBufferSize: 0
      });
      f.Hasher = _.extend({
        /**
         * Configuration options.
         */
        cfg: u.extend(),
        /**
         * Initializes a newly created hasher.
         *
         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
         *
         * @example
         *
         *     var hasher = CryptoJS.algo.SHA256.create();
         */
        init: function(t) {
          this.cfg = this.cfg.extend(t), this.reset();
        },
        /**
         * Resets this hasher to its initial state.
         *
         * @example
         *
         *     hasher.reset();
         */
        reset: function() {
          _.reset.call(this), this._doReset();
        },
        /**
         * Updates this hasher with a message.
         *
         * @param {WordArray|string} messageUpdate The message to append.
         *
         * @return {Hasher} This hasher.
         *
         * @example
         *
         *     hasher.update('message');
         *     hasher.update(wordArray);
         */
        update: function(t) {
          return this._append(t), this._process(), this;
        },
        /**
         * Finalizes the hash computation.
         * Note that the finalize operation is effectively a destructive, read-once operation.
         *
         * @param {WordArray|string} messageUpdate (Optional) A final message update.
         *
         * @return {WordArray} The hash.
         *
         * @example
         *
         *     var hash = hasher.finalize();
         *     var hash = hasher.finalize('message');
         *     var hash = hasher.finalize(wordArray);
         */
        finalize: function(t) {
          t && this._append(t);
          var n = this._doFinalize();
          return n;
        },
        blockSize: 16,
        /**
         * Creates a shortcut function to a hasher's object interface.
         *
         * @param {Hasher} hasher The hasher to create a helper for.
         *
         * @return {Function} The shortcut function.
         *
         * @static
         *
         * @example
         *
         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
         */
        _createHelper: function(t) {
          return function(n, a) {
            return new t.init(a).finalize(n);
          };
        },
        /**
         * Creates a shortcut function to the HMAC's object interface.
         *
         * @param {Hasher} hasher The hasher to use in this HMAC helper.
         *
         * @return {Function} The shortcut function.
         *
         * @static
         *
         * @example
         *
         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
         */
        _createHmacHelper: function(t) {
          return function(n, a) {
            return new U.HMAC.init(t, a).finalize(n);
          };
        }
      });
      var U = w.algo = {};
      return w;
    }(Math);
    return e;
  });
})(j);
var Z = j.exports;
const J = Math.pow(2, 32), S = () => Z.lib.WordArray.random(4).words[0] / J, P = (l) => S() * l.length | 0, k = (l) => l[P(l)], O = /[^a-zA-ZßäöüÄÖÜ]/g, G = /[a-zA-ZßäöüÄÖÜ]/g, K = (l) => {
  const r = l[0];
  return r ? r.toUpperCase() + l.slice(1) : l;
}, y = {
  lower: "abcdefghijklmnopqrstuvwxyz",
  upper: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
  number: "0123456789",
  special: "~!@#$%^&()_+-={}[];',."
};
y.all = y.lower + y.upper + y.number + y.special;
const T = (l = "*", r = 13, e = {}) => {
  let s = !1;
  e.chars && (l = e.chars, r = l.length, s = !0);
  let i = "", o = "";
  if (l.includes("?") && (i += e.chars), l.includes("a") && (i += y.lower), l.includes("A") && (i += y.upper), l.includes("0") && (i += y.number), l.includes("!") && (i += y.special), l.includes("*") && (i += y.all), s && (i += l), e.exclude) {
    let g = typeof e.exclude == "string" ? e.exclude : e.exclude.join("");
    g = g.replace(new RegExp("[\\]]+", "g"), ""), i = i.replace(new RegExp("[" + g + "]+", "g"), ""), e.exclude.includes("]") && (i = i.replace(new RegExp("[\\]]+", "g"), ""));
  }
  for (; r--; )
    o += i.charAt(S() * i.length);
  return o;
}, L = (() => {
  try {
    return S(), !0;
  } catch {
    return !1;
  }
})();
class v {
  policy;
  options;
  static fallbackLength = 16;
  constructor(r, e) {
    if (!L)
      throw new F();
    this.policy = r, this.options = e ?? {
      timeout: 5
    };
  }
  static generateAnyPassword() {
    if (!L)
      throw new F();
    return T("*", v.fallbackLength);
  }
  async generatePassword() {
    const { pattern: r, chars: e, exclude: s } = this.translatePolicyRestrictionsForPasswordGeneration(), i = this.getMinLength();
    return this.generate(() => T(r, i, { chars: e, exclude: s }));
  }
  getMinLength = () => {
    const r = this.getLongestMinLength(), e = this.getShortestMaxLength(), s = this.policy.minComplexity <= 3 ? v.fallbackLength : 20;
    return e && s > e ? e : r && r < s ? s : r || s;
  };
  getLongestMinLength = () => {
    const r = this.policy.rules.filter(
      (e) => e instanceof E && e.config.min
    );
    return r.length === 0 ? void 0 : Math.max(...r.map((e) => e.config.min));
  };
  getShortestMaxLength = () => {
    const r = this.policy.rules.filter(
      (e) => e instanceof E && e.config.max
    );
    return r.length === 0 ? void 0 : Math.min(...r.map((e) => e.config.max));
  };
  translatePolicyRestrictionsForPasswordGeneration = () => {
    const r = this.removeForbiddenCharPoolsFromPattern("aA0!?", this.getForbiddenCharPools()), e = this.getDemandedChars(), s = this.getForbiddenChars();
    return { pattern: r, chars: e, exclude: s };
  };
  getForbiddenCharPools = () => this.policy.rules.filter(
    (e) => e instanceof I && e.config.max === 0
  ).map((e) => e.config.charPools).flat();
  removeForbiddenCharPoolsFromPattern = (r, e) => {
    let s = r;
    for (const i of e)
      switch (i) {
        case "uppercase":
          s = s.replace("A", "");
          break;
        case "lowercase":
          s = s.replace("a", "");
          break;
        case "numbers":
          s = s.replace("0", "");
          break;
        case "special":
          s = s.replace("!", "");
          break;
      }
    return s;
  };
  getForbiddenChars = () => this.policy.rules.filter(
    (e) => e instanceof z && e.config.max === 0
  ).map((e) => e.config.chars).join("");
  static generateAnyPassphrase() {
    if (!L)
      throw new F();
    return this.buildPassphrase(M, {});
  }
  async generatePassphrase() {
    const { options: r, filteredWordlist: e } = this.translatePolicyRestrictionsForPassphraseGeneration();
    return this.generate(() => v.buildPassphrase(e, r));
  }
  translatePolicyRestrictionsForPassphraseGeneration = () => {
    const r = this.getForbiddenChars(), e = this.getBlocklistedWords(), s = this.getDemandedChars(), i = v.filterWordlist(M, r, s, e);
    return { options: this.getPassphraseOptionsFromPolicy(), filteredWordlist: i };
  };
  getBlocklistedWords = () => this.policy.rules.filter((e) => e instanceof N).flatMap((e) => e.config.blocklist);
  getDemandedChars = () => this.policy.rules.filter(
    (e) => e instanceof z && (e.config.max === void 0 || e.config.max !== 0)
  ).map((e) => e.config.chars).join("");
  getDemandedCharPools = () => this.policy.rules.filter(
    (e) => e instanceof I && (e.config.max === void 0 || e.config.min)
  ).map((e) => e.config.charPools).flat();
  static filterWordlist = (r, e, s, i) => {
    let o = r;
    return o = v.removeForbiddenCharsFromWordlist(o, e), o = v.leaveOnlyDemandedCharsInWordlist(o, s), o = v.removeBlocklistedWordsFromWordlist(o, i), o;
  };
  static removeForbiddenCharsFromWordlist = (r, e) => {
    const s = e.replace(O, "");
    return s.length === 0 ? r : r.filter((i) => !Array.from(s).some((o) => i.includes(o)));
  };
  static leaveOnlyDemandedCharsInWordlist = (r, e) => {
    const s = e.replace(O, "");
    return s.length === 0 ? r : r.filter((i) => Array.from(s).some((o) => i.includes(o)));
  };
  static removeBlocklistedWordsFromWordlist = (r, e) => e.length === 0 ? r : r.filter((s) => e.every((i) => !s.includes(i)));
  getPassphraseOptionsFromPolicy = () => {
    const r = this.getMinLength(), e = this.getDemandedCharPools(), s = this.getForbiddenCharPools(), o = this.getDemandedChars().replace(G, ""), g = {
      desiredNumberOfWords: Math.ceil(r / 6),
      // average word has length of 6. Passphrases exist, to be memorable. So we should avoid unnecessary length.
      containSpecial: e.some((p) => p === "special"),
      containNumber: e.some((p) => p === "numbers"),
      useTitleCase: e.some((p) => p === "uppercase"),
      demandedChars: o
    };
    return s.some((p) => p === "special") && (g.separator = ""), g;
  };
  static buildPassphrase = (r, e) => {
    const {
      desiredNumberOfWords: s = 3,
      separator: i = "-",
      useTitleCase: o = !1,
      containNumber: g = !1,
      containSpecial: p = !1,
      demandedChars: w
    } = e;
    let f = Array.from({ length: s }, () => k(r));
    if (o && (f = f.map(K)), g && (f[P(f)] += k([
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9
    ]).toString()), p) {
      const u = "!#$%&*+:;<=>?@^|~".split("");
      u.includes(i) && u.splice(u.indexOf(i), 1), f[P(f)] += k(u);
    }
    if (w)
      for (const u of w)
        f[P(f)] += u;
    return f.join(i);
  };
  async generate(r) {
    const e = [], s = Date.now();
    for (; ; ) {
      const i = await r();
      if (this.policy.validate(i).isValid)
        return i;
      if (e.push(i), Date.now() - s >= this.options.timeout * 1e3)
        throw new V(this.policy, this.options.timeout, e);
    }
  }
}
export {
  v as Generator,
  v as default,
  L as isCryptographicSecureRandom
};
